// routing
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import 'react-international-phone/style.css';
import './App.css';
import HomeFlow from './Pages/HomeFlow';
import Receipt from './Pages/Receipt';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<HomeFlow />} index />
        <Route path="/:receiptId/:uuid" element={<Receipt />} index />
      </Route>
    )
  );

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
